import { cn } from "@bentolabs/kit/utils";

type Props = {
  className?: string;
};
export const Header = ({ className }: Props) => {
  return (
    <div
      className={cn(
        "text-nobel/50 hidden grid-cols-[2fr_1.5fr_1fr_1fr_1fr_0.5fr] items-center rounded-[10px] px-3 font-normal sm:grid",
        className
      )}
    >
      <div>Pool</div>
      <div>Balance</div>
      <div>Total Points</div>
      <div>24h Points</div>
      <div className="">Action</div>
      <div />
    </div>
  );
};
